import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  activo: null,
  activoError: "",
  formError: "",
};

export default function ActivoFijoReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_ACTIVO:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_ACTIVO:
      return { ...state, saveLoading: action.payload };
    case actions.GET_ACTIVO:
      return { ...state, activo: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.ACTIVO_FAIL:
      return { ...state, activoError: action.payload };
    default:
      return state;
  }
}
